import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export const ScrollToTop = () => {
  const { pathname } = useLocation();

  if (window.history.scrollRestoration) {
    window.history.scrollRestoration = "manual";
  }
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};
